export default `
fragment FollowedPromptFragment on followed_prompts {
  userId: user_id
  promptId: prompt_id
}
`;
